import React from 'react';
import "./i18n"
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ParallaxProvider } from 'react-parallax';
import { motion , useScroll , useTransform } from 'framer-motion';
import { AnimatePresence } from "framer-motion";
import { LazyMotion , domAnimation } from 'framer-motion';

import 'aos/dist/aos.css'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
 <LazyMotion features={domAnimation}>
     <App />
    </LazyMotion> 
     </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
